import { mutatorAction } from 'satcheljs';
import store from '../store/Store';
import type { AvailabilityState } from '../store/schema/MeetingTypeEditOptionState';
import { AvailabilityType } from '../store/schema/MeetingTypeEditOptionState';
import { today, addDays } from 'owa-datetime';
import { createSchedulingHoursFromUserWorkingHours } from 'owa-scheduling-hours';
import { isFeatureEnabled } from 'owa-feature-flags';

const FIVE_YEARS_IN_DAYS = 365 * 5;

/**
 * Action to update the service availability in the store.
 * TODO: Update this function to orchestrator
 */
export default mutatorAction(
    'setMeetingTypeAvailability',
    function setMeetingTypeAvailability(newAvailability: AvailabilityState, markAsDirty?: boolean) {
        const serviceAvailability = store.meetingTypeEditState.availability;

        // If there's a change in the availability type, then setup/clear the other availability properties accordingly
        if (newAvailability.availabilityType) {
            serviceAvailability.availabilityType = newAvailability.availabilityType;
            if (newAvailability.availabilityType === AvailabilityType.DefaultSetup) {
                serviceAvailability.isDateRestricted = false;
                serviceAvailability.startDate = undefined;
                serviceAvailability.endDate = undefined;
                serviceAvailability.customHours = undefined;
            } else {
                serviceAvailability.customHours = createSchedulingHoursFromUserWorkingHours();
            }
        }

        // Update custom availability related properties, only when they are applicable
        if (serviceAvailability.availabilityType === AvailabilityType.Custom) {
            if (newAvailability.isDateRestricted !== undefined) {
                serviceAvailability.isDateRestricted = newAvailability.isDateRestricted;
                if (
                    newAvailability.isDateRestricted &&
                    serviceAvailability.startDate === null &&
                    serviceAvailability.endDate === null
                ) {
                    serviceAvailability.startDate = today();
                    serviceAvailability.endDate = addDays(today(), 7);
                }
            }

            if (newAvailability.startDate) {
                serviceAvailability.startDate = newAvailability.startDate;
                if (
                    serviceAvailability.endDate &&
                    serviceAvailability.endDate < serviceAvailability.startDate
                ) {
                    serviceAvailability.endDate = serviceAvailability.startDate;
                }
                if (
                    isFeatureEnabled('bookwithme-customSlots') &&
                    serviceAvailability.isDateRestricted &&
                    (serviceAvailability.endDate === null ||
                        serviceAvailability.endDate === undefined)
                ) {
                    serviceAvailability.endDate = addDays(
                        serviceAvailability.startDate,
                        FIVE_YEARS_IN_DAYS
                    );
                }
            }
            if (newAvailability.endDate) {
                serviceAvailability.endDate = newAvailability.endDate;
            }
            if (newAvailability.customHours) {
                serviceAvailability.customHours = newAvailability.customHours;
            }
        }

        // Mark the form as dirty if requested
        serviceAvailability.isDirty = markAsDirty;
    }
);
